

<div class="backgroundDialog" style="width: 100%; padding: 0px;margin: auto;">



    <div style="text-align: center; width: 20%;display: inline-block;  " >
      <mat-card style="border-radius: 0px 30px 30px 0px ; color: white;
                        background-color: rgb(46, 163, 80); font-size: 20px;">
          Assinar&nbsp;Feedback 
      </mat-card>
    </div>

    <div style="text-align: right; width: 78%; display: inline-block; " >
      <button  [mat-dialog-close]="true">
        <img src="../../assets/img/icones/fecharJanela.png" width="100%">
    </button>
    </div>
  
  
    <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center;">
      <div style="margin-top: 7px; ">Finalizar a monitoria</div>
    </div>
  
    <div style="width: 100%;">
      <table style="width: 99.8%; margin: auto;">
          <tr>
              <td style="width:100%">
                  <div>
                      
                          
                          <table style="text-align: left; width: 100%; height: 98%;">
                              
                              <tr style="cursor: pointer;">
                                <td style="width: 100%; height: 100%;" >
                                  <mat-card class="mat-elevation-z5" style="font-size: 12px; height: 100%;">
                                      
                                      
                                      

                                    <form  [formGroup]="formLogin" novalidate (ngSubmit)="assinar()" *ngIf="login">
                                        
                                        <div style="width: 100%; text-align: center;">
                                          <label style="color: red;"><b> AVALIADOR </b><br/>Certifique-se que a tela monitoria foi salva antes de assinar</label>
                                        </div>
                                        <br/>
                                        <div>
                                            <img src="../../assets/img/icones/usuarios.png" width="27px">&nbsp;
                                            <mat-form-field appearance="outline" style="width: 250px;  font-size: 12px;">
                                                <mat-label>Número do Registro  &nbsp;(RE)</mat-label>
                                                <input matInput placeholder="usuario" formControlName="usuario" readonly >
                                            </mat-form-field>
                                        </div>
                                      
                                        <div>
                                          <img src="../../assets/img/icones/comentario.png" width="23px">&nbsp;&nbsp;
                                          <mat-form-field  appearance="outline" style="width: 250px; font-size: 12px;">
                                              <mat-label>          
                                              Comentário do avaliado
                                              </mat-label>
                                              <textarea matInput placeholder="Descrição" style="white-space: pre-line;" formControlName="feedback"></textarea>
                                          </mat-form-field>
                                        </div>

                                        <div>
                                            <img src="../../assets/img/icones/chave.png" width="23px" >&nbsp;&nbsp;
                                            <mat-form-field appearance="outline" style="width: 250px; font-size: 12px;">
                                                <mat-label>Senha do avaliado</mat-label>
                                                <input matInput  [type]="hide ? 'password' : 'text'" formControlName="senha">
                                                <button mat-icon-button type="button" matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                                    <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                                </button>
                                            </mat-form-field>
                                        </div>
                                      
                                        
                                      
                                        
                                        <div>
                                            <div *ngIf="!aguarde" style="width: 100%; font-size: 12px ">
                                                <button mat-raised-button  type="submit" style="width: 120px;background-color:rgb(46, 163, 80);  color: white;" >
                                                    Assinar
                                                </button>
                                            </div>
                                        </div>

                                        <br/>
                                        
                                      </form>




                                  </mat-card>
                                </td>                              
                            </tr>
  
                        </table>


                  </div>
              </td>
          </tr>
      </table>
      <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; text-align: center;">
        <div style="margin-top: 7px; margin-left: 15px; color: white;">Concordo com o Feedback aplicado</div>
      </div>
      
      
    </div>
  
  </div>